import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeDeviceQueryCriteriaClass extends BaseCriteriaModel {
  name?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  model?: Optional<string> = Optional.empty();
  brand?: Optional<string> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();
}

export class StockTakeDeviceCriteriaModelQuery {
  query = '';

  constructor(stockTakeDeviceCriteriaModel: StockTakeDeviceQueryCriteriaClass) {

    if (!stockTakeDeviceCriteriaModel) {
      return;
    }
    
    this.query += stockTakeDeviceCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += stockTakeDeviceCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += stockTakeDeviceCriteriaModel.model.filter(x => x !== '').map(x => '&model=' + x).orElse('');
    this.query += stockTakeDeviceCriteriaModel.brand.filter(x => x !== '').map(x => '&brand=' + x).orElse('');
    this.query += stockTakeDeviceCriteriaModel.created_date.filter(x => x !== '').map(x => '&date_created=' + x).orElse('');
    this.query += stockTakeDeviceCriteriaModel.updated_date.filter(x => x !== '').map(x => '&date_lastupdated=' + x).orElse('');

    this.query += '&calcTotalRecords=' + stockTakeDeviceCriteriaModel.calcTotalRecords;
    this.query += '&status=' + stockTakeDeviceCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeDeviceCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeDeviceCriteriaModel.order;
    this.query += '&offset=' + stockTakeDeviceCriteriaModel.offset + '&limit=' + stockTakeDeviceCriteriaModel.limit;
  }
}
